module.exports = __webpack_public_path__ + "img/Strawberries.2cb868f0.png";